import { CreateLiveMentionManualDto } from '@app/api/audit-api';
import { useTimezone } from '@app/core/hooks/useTimezone';
import { Station } from '@app/core/types/stations';
import { DateTimeStr, now } from '@mi-front/core';
import { DateTimeField, Form, Modal } from '@mi-front/ui';
import { Grid } from '@mui/material';
import moment from 'moment-timezone';
import { useIntl } from 'react-intl';
import { MentionNameFields } from './MentionNameFields';
import { createMentionManualSchema } from './validation';

interface Props {
  station: Station;
  datetime?: DateTimeStr;
  submitFn: (data: CreateLiveMentionManualDto) => Promise<any>;
  cancel: () => any;
}

type MentionManualFormValues = {
  datetime: string;
  source: 'schedules' | 'custom';
  mentionSchedules: null | { name: string; description: string };
  mentionCustom: { name: string; description: string };
};

export function MentionManualForm({ station, datetime, submitFn, cancel }: Props) {
  const { $t } = useIntl();
  const tz = useTimezone();

  return (
    <Form<MentionManualFormValues>
      initialValues={{
        datetime: datetime || now(),
        source: 'schedules',
        mentionSchedules: null,
        mentionCustom: {
          name: '',
          description: '',
        },
      }}
      validationSchema={createMentionManualSchema}
      onSubmit={(data) => {
        return submitFn({
          datetime: data.datetime as DateTimeStr,
          ...(data.source === 'schedules' ? data.mentionSchedules! : data.mentionCustom),
        });
      }}
      onCancel={cancel}
      actions={(formikProps, defaultActions) => <Modal.Footer>{defaultActions}</Modal.Footer>}
    >
      <Modal.Body>
        <Grid container spacing={2}>
          <Grid item xs={10}>
            <DateTimeField
              name="datetime"
              dateLabel={$t({
                id: 'common.text.date',
                defaultMessage: 'Fecha',
              })}
              timeLabel={$t({
                id: 'common.text.time',
                defaultMessage: 'Hora',
              })}
              isOutsideRange={(date) => moment(date) > moment()}
              tz={tz}
              withSeconds
              markRequired
            />
          </Grid>
        </Grid>
        <MentionNameFields station={station} />
      </Modal.Body>
    </Form>
  );
}
